import { Link } from "@tanstack/react-router";
import { LockKeyhole } from "lucide-react";
import { Button } from "@/components/ui/button";

/** Consistent signed-out empty state used by gated pages. */
export function SignInRequired({
  title,
  description,
}: {
  title: string;
  description?: string;
}) {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-sm text-center space-y-4">
        <div className="mx-auto flex size-12 items-center justify-center rounded-2xl bg-primary/10 text-primary">
          <LockKeyhole className="size-6" />
        </div>
        <h1 className="font-[family-name:var(--font-display)] text-2xl font-extrabold text-ink">
          {title}
        </h1>
        {description ? (
          <p className="text-sm text-ink-muted">{description}</p>
        ) : null}
        <Link to="/login" className="block">
          <Button variant="scan" size="full">Sign in</Button>
        </Link>
        <Link to="/" className="block text-sm text-ink-muted underline">
          Back to home
        </Link>
      </div>
    </div>
  );
}
